import React, { useState } from "react";
import Api from "../../services/Api";
import { EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import useAuth from "../../routes/login/AuthContext";
import { Modal } from "../Modal";
import { Link } from "../Link";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Checkbox } from "../../UI/Checkbox";
import { Box } from "../../UI/Box";
import { useSnackbar } from "../../hooks/useSnackbar";

export const NetworkClearModal = ({ onClose, subnetwork }) => {
  const [accepted, setAccepted] = useState(false);
  const { setIsOpen } = useModalContext();
  const { showErrorSnackbar } = useSnackbar();
  const { getAuthToken } = useAuth();

  const onHide = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  const handleClear = async () => {
    const success = await Api.clearNetwork(subnetwork.l1Id, subnetwork.l2Id, await getAuthToken());

    if (success) {
      onHide();
    } else {
      showErrorSnackbar();
    }
  };

  const handleAccept = (e) => {
    setAccepted(e.target.checked);
  };

  return (
    <Modal
      title="Confirm Subnetwork Clear"
      actions={
        <>
          <Button appearance="subtle" onClick={onHide}>
            Cancel
          </Button>
          <Button appearance="primary" onClick={handleClear} isDisabled={!accepted}>
            Clear subnetwork
          </Button>
        </>
      }
    >
      <Box px={3} py={2}>
        <Typography variant="body2" gutterBottom>
          You are about to remove all users from the subnetwork listed below. We recommend only doing this after your
          matching period has closed for the year. Users should be cleared from the prior year before going live with
          matching for the upcoming year.
        </Typography>
        <Typography variant="body2" gutterBottom>
          A fee of $1,000 will be charged to reinstate cleared users. If you have questions about how clears work,
          please call us at {PHONE_NUMBER} or e-mail <Link href={`mailto:${EMAIL_ADDRESS}`}>{EMAIL_ADDRESS}</Link>
        </Typography>
        <Typography variant="body2" gutterBottom>
          <b>Subnetwork to Clear:</b> {subnetwork.l2Name} ({subnetwork.usersInNetwork} users)
        </Typography>
        <Checkbox
          name="accept"
          defaultChecked={false}
          onChange={handleAccept}
          label="I understand that reinstating removed users will incur a $1,000 fee"
        />
      </Box>
    </Modal>
  );
};
